// Print stylesheet for the Monthly Financial Report.
//
// The printable report is portalled straight into <body> with
// PRINT_ROOT_CLASS. On screen it's hidden; when printing, EVERY other child
// of <body> (the app shell with its sidebar and top bar, MUI dialogs and
// popovers, snackbars) is hidden instead, so only the report prints.

export const PRINT_ROOT_CLASS = "bs-print-root";

export const printStyles = `
@media screen {
  .${PRINT_ROOT_CLASS} { display: none !important; }
}

@media print {
  @page { size: A4 portrait; margin: 12mm 12mm 14mm; }

  html, body { background: #fff !important; }
  body > *:not(.${PRINT_ROOT_CLASS}) { display: none !important; }

  .${PRINT_ROOT_CLASS} {
    display: block !important;
    color: #212121;
    font-family: "Helvetica Neue", Arial, sans-serif;
    font-size: 10pt;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .${PRINT_ROOT_CLASS} .pr-header { text-align: center; margin-bottom: 4mm; }
  .${PRINT_ROOT_CLASS} .pr-header h1 { font-size: 16pt; margin: 0; }
  .${PRINT_ROOT_CLASS} .pr-header h2 { font-size: 11pt; font-weight: 400; color: #37474f; margin: 1mm 0 0; }
  .${PRINT_ROOT_CLASS} .pr-header p { font-size: 9pt; color: #757575; margin: 1mm 0 0; }

  .${PRINT_ROOT_CLASS} .pr-summary { display: flex; gap: 3mm; }
  .${PRINT_ROOT_CLASS} .pr-box {
    flex: 1; text-align: center; padding: 2mm 1mm; border-radius: 1.5mm; border: 0.3mm solid;
  }
  .${PRINT_ROOT_CLASS} .pr-box span { display: block; font-size: 7.5pt; color: #757575; }
  .${PRINT_ROOT_CLASS} .pr-box strong { display: block; font-size: 12pt; margin-top: 0.5mm; }
  .${PRINT_ROOT_CLASS} .pr-slate { background: #eceff1; border-color: #37474f; color: #37474f; }
  .${PRINT_ROOT_CLASS} .pr-green { background: #e8f5e9; border-color: #2e7d32; color: #2e7d32; }
  .${PRINT_ROOT_CLASS} .pr-red { background: #fdecea; border-color: #c62828; color: #c62828; }
  .${PRINT_ROOT_CLASS} .pr-equation { font-size: 8.5pt; color: #757575; margin: 2mm 0 4mm; }

  .${PRINT_ROOT_CLASS} .pr-section { margin-bottom: 4mm; break-inside: avoid; page-break-inside: avoid; }
  .${PRINT_ROOT_CLASS} .pr-section h3 { font-size: 10.5pt; margin: 0 0 1.5mm; break-after: avoid; }

  .${PRINT_ROOT_CLASS} .pr-table { width: 100%; border-collapse: collapse; font-size: 9pt; }
  .${PRINT_ROOT_CLASS} .pr-table th,
  .${PRINT_ROOT_CLASS} .pr-table td { border: 0.2mm solid #e0e0e0; padding: 1.2mm 2mm; text-align: left; }
  .${PRINT_ROOT_CLASS} .pr-table thead th { background: #f5f6f8; }
  .${PRINT_ROOT_CLASS} .pr-table tr { break-inside: avoid; page-break-inside: avoid; }
  .${PRINT_ROOT_CLASS} .pr-table tfoot td { font-weight: 700; }
  .${PRINT_ROOT_CLASS} .pr-num { text-align: right !important; white-space: nowrap; width: 32%; }
  .${PRINT_ROOT_CLASS} .pr-green-head thead th, .${PRINT_ROOT_CLASS} .pr-green-head tfoot td { background: #e8f5e9; }
  .${PRINT_ROOT_CLASS} .pr-green-head tfoot td { color: #2e7d32; }
  .${PRINT_ROOT_CLASS} .pr-red-head thead th, .${PRINT_ROOT_CLASS} .pr-red-head tfoot td { background: #fdecea; }
  .${PRINT_ROOT_CLASS} .pr-red-head tfoot td { color: #c62828; }
  .${PRINT_ROOT_CLASS} .pr-subhead td { font-size: 7.5pt; font-weight: 700; color: #757575; text-transform: uppercase; }
  .${PRINT_ROOT_CLASS} .pr-emphasis td { font-weight: 700; background: #e8f5e9; }
  .${PRINT_ROOT_CLASS} .pr-status-reconciled { color: #2e7d32; font-weight: 700; }
  .${PRINT_ROOT_CLASS} .pr-status-needs_review { color: #c62828; font-weight: 700; }

  .${PRINT_ROOT_CLASS} .pr-payments {
    display: flex; margin-top: 2mm; border: 0.5mm solid #e69100; background: #fff8e1; border-radius: 2mm;
  }
  .${PRINT_ROOT_CLASS} .pr-payments div { flex: 1; text-align: center; padding: 2mm; }
  .${PRINT_ROOT_CLASS} .pr-payments span { display: block; font-size: 8pt; color: #757575; }
  .${PRINT_ROOT_CLASS} .pr-payments strong { display: block; font-size: 13pt; }
  .${PRINT_ROOT_CLASS} .pr-warning { color: #c62828; font-size: 9pt; }
  .${PRINT_ROOT_CLASS} .pr-warning ul { margin: 1mm 0 0; padding-left: 5mm; }
  .${PRINT_ROOT_CLASS} .pr-note { font-size: 8pt; color: #757575; margin: 1mm 0 0; }
  .${PRINT_ROOT_CLASS} .pr-status-monthly_only { color: #757575; }

  /* Monthly Brief Report: one month section per printed page */
  .${PRINT_ROOT_CLASS} .pr-month + .pr-month { break-before: page; page-break-before: always; }
  .${PRINT_ROOT_CLASS} .pr-month-title {
    font-size: 13pt; margin: 2mm 0 2mm; padding-bottom: 1mm; border-bottom: 0.4mm solid #e0e0e0;
  }

  .${PRINT_ROOT_CLASS} .pr-footer {
    display: flex; justify-content: space-between; margin-top: 4mm; padding-top: 1.5mm;
    border-top: 0.2mm solid #e0e0e0; font-size: 7.5pt; color: #757575;
  }
}
`;
